import React from 'react';
import { Link } from 'react-router-dom';
import sty from './ErrorPage.module.css';

const NotFound = () => {
    return (
        <div className={sty['error__contents-outer']}>
            <div className={sty['error__tit-outer']}>
                <h1 className={sty['error__page-tit']}>404 Page Not Found</h1>
                <p className={sty['error__contents-txt']}>お探しのページは見つかりませんでした</p>
                <Link className={sty['error__link']} to="/">ホームに戻る</Link>
            </div>
        </div>
    );
};

export default NotFound;